import { useMutation } from 'react-query';
import request from '../../../helpers/request';

const changeAddDocsAddress = async ({ docId, addressId }) => {
  return await request.post(
    `/Docs/addAddress`,
    {
      docId,
      addressId,
    },
    'При добавлении адреса произошла ошибка',
    'Error'
  );
};

const useAddDocsAddress = () => {
  const mutation = useMutation(changeAddDocsAddress, {
    onSuccess: (data) => {
      if (data === 'Error') return;
    },
  });

  return {
    isLoadingDocsAddress: mutation.isLoading,
    addDocsAddress: mutation.mutateAsync,
  };
};

export default useAddDocsAddress;
